
import { IPlanificationPhase } from '@/entity/planification/planification-phase';
import { IPlanificationPhaseProfile } from '@/entity/planification/planification-phase-profile';
import { formatCurrencyByProject } from '@t/format-currency';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanificationValidation } from '../interface/project-planification';

@Component({})
export default class ProfileItem extends Vue {
    @Prop({ required: true }) currentProfile!: IPlanificationPhaseProfile;
    @Prop({ required: true }) selectedPlanificationPhaseToUpdate!: IPlanificationPhase;
    @Prop({ required: true }) profileIndex!: number;
    @Prop({ required: true }) showValidation!: boolean;
    @Prop({ required: true }) validationObject!: PlanificationValidation[];

    get employeeRole() {
        const employeeLabel = this.currentProfile.employeeRole?.label ?? '';
        return this.currentProfile.employeeRole && !employeeLabel ? ' - ' + employeeLabel : '';
    }

    get budgetCost() {
        return this.currentProfile.totalRate ? ' - ' + this.formatAmountWithCurrency(this.currentProfile.totalRate) : '';
    }

    get debug() {
        const profile = JSON.parse(JSON.stringify(this.currentProfile)) as IPlanificationPhaseProfile;
        profile.planificationPhaseProfileWorkDays = [];
        (profile as any).calendarPropWorkDays = [];
        return profile;
    }

    get employeeName () {
        if (!this.currentProfile.employeeName && this.currentProfile.employee?.employeeDisplayName) {
            return this.currentProfile.employee.employeeDisplayName;
        }
        return this.currentProfile.employeeName;
    }

    get validationStyle() {
        return {
            display:
                this.showValidation === true &&
                this.validationObject.length > this.profileIndex &&
                (this.validationObject[this.profileIndex].profil === true ||
                    this.validationObject[this.profileIndex].studio === true)
                    ? 'inline'
                    : 'none'
        };
    }

    // warning : Code dupliqué,
    formatAmountWithCurrency(value: number): string {
        return formatCurrencyByProject(value, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
}
